import { render } from "./진료과 안내 리스트.vue?vue&type=template&id=679f78d6"
import script from "./진료과 안내 리스트.vue?vue&type=script&lang=js"
export * from "./진료과 안내 리스트.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__